import { render, staticRenderFns } from "./CopyableText.vue?vue&type=template&id=4b2e0db8&scoped=true&lang=pug&"
import script from "./CopyableText.vue?vue&type=script&lang=js&"
export * from "./CopyableText.vue?vue&type=script&lang=js&"
import style0 from "./CopyableText.vue?vue&type=style&index=0&id=4b2e0db8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e0db8",
  null
  
)

export default component.exports